module.exports = __webpack_public_path__ + "static/media/cash-delete.dadbd78e.png";